import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { disconnectSlack, getSlackStatus, startSlackOauth } from "@/features/people/people.api";

/** Connection status query. Refetched after the OAuth popup closes. */
export function useSlackStatus(workspaceId: string) {
  return useQuery({
    queryKey: ["slack-status", workspaceId],
    queryFn: () => getSlackStatus(workspaceId),
    staleTime: 30_000,
  });
}

/** Kicks off OAuth, returns the authorize URL the caller redirects to. */
export function useStartSlackOauth(workspaceId: string) {
  return useMutation({
    mutationFn: () => startSlackOauth(workspaceId),
  });
}

export function useDisconnectSlack(workspaceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => disconnectSlack(workspaceId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["slack-status", workspaceId] }),
  });
}
